import React, {Component} from 'react';
import { Platform, Dimensions, Keyboard, View, Image, KeyboardAvoidingView,
         Text, TextInput, StyleSheet, TouchableHighlight } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import LinearGradient from 'react-native-linear-gradient';
import MessageBox from "../ui/MessageBox";
import ChatView from "../../components/ui/ChatView";
import RoomClient from "../../utils/chinesepark/RoomClient";
import IsMobile from "../../utils/IsMobile";
import { Button, } from "native-base";
import { withTranslation } from "react-i18next";
//import FastImage from 'react-native-fast-image';
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.screens.chinesepark.room;

const KeyboardView = Platform.OS === 'ios' ? KeyboardAvoidingView : View;

class ChatPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            keyboard: false,
            popupInput: false,
            chatHeight: 0,
            stayTime: this.getStayTime(),
        };

        this.keyboardWillShow = this.keyboardWillShow.bind(this);
        this.keyboardDidShow = this.keyboardDidShow.bind(this);
        this.keyboardWillHide = this.keyboardWillHide.bind(this);
        this.keyboardDidHide = this.keyboardDidHide.bind(this);
        this.setupChatView = this.setupChatView.bind(this);
        this.onError = this.onError.bind(this);
        this.onJoin = this.onJoin.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onChatMsg = this.onChatMsg.bind(this);
        this.onBanChat = this.onBanChat.bind(this);
        this.onAddBlack = this.onAddBlack.bind(this);
        this.onStopVideo = this.onStopVideo.bind(this);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.onStayTime = this.onStayTime.bind(this);
    }

    componentDidMount() {
        RoomClient.events.addListener("error", this.onError);
        RoomClient.events.addListener("onJoin", this.onJoin);
        RoomClient.events.addListener("onLeave", this.onLeave);
        RoomClient.events.addListener("onChatMsg", this.onChatMsg);
        RoomClient.events.addListener("onBanChat", this.onBanChat);
        RoomClient.events.addListener("onAddBlack", this.onAddBlack);
        RoomClient.events.addListener("stopVideo", this.onStopVideo);
        RoomClient.events.addListener("onDisconnect", this.onDisconnect);

        this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow);
        this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this.keyboardDidShow);
        this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide);
        this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this.keyboardDidHide);

        if (this._stayTimer === undefined) {
            this._stayTimer = setInterval(this.onStayTime, 1000);
        }
        this.onStayTime();
    }

    componentWillUnmount() {
        if (this._stayTimer !== undefined) {
            clearInterval(this._stayTimer);
            this._stayTimer = undefined;
        }
        this.keyboardWillShowListener.remove();
        this.keyboardDidShowListener.remove();
        this.keyboardWillHideListener.remove();
        this.keyboardDidHideListener.remove();
        RoomClient.events.removeListener("error", this.onError);
        RoomClient.events.removeListener("onJoin", this.onJoin);
        RoomClient.events.removeListener("onLeave", this.onLeave);
        RoomClient.events.removeListener("onChatMsg", this.onChatMsg);
        RoomClient.events.removeListener("onBanChat", this.onBanChat);
        RoomClient.events.removeListener("onAddBlack", this.onAddBlack);
        RoomClient.events.removeListener("stopVideo", this.onStopVideo);
        RoomClient.events.removeListener("onDisconnect", this.onDisconnect);
    }

    keyboardWillShow() {
        this.setState({keyboard: true});
    }

    keyboardDidShow() {
        this.setState({keyboard: true});
    }

    keyboardWillHide() {
        //this.setState({keyboard: false});
    }

    keyboardDidHide() {
        this.setState({keyboard: false});
    }

    setupChatView(r) {
        this._chatView = r;
        if (this._chatView) {
            this._chatView.queryHeight();
        }
    }

    onError(err) {
        this.props.chatStore.addTip(err);
    }

    onJoin(user, opts) {
        this.props.chatStore.addJoin(user);
    }

    onLeave(userid, error, opts) {
        if (userid === RoomClient.userid && RoomClient.LEAVE_ROOM_REJOIN === error) {
            this.props.chatStore.addTip(this.props.t("userLoginAtOtherPlace"));
            return;
        }

        if (RoomClient.LEAVE_ROOM_KICKOUT === error) {
            this.props.chatStore.addKickout(RoomClient.getUser(userid), RoomClient.getUser(opts.operid));
        }
        else {
            this.props.chatStore.addLeave(RoomClient.getUser(userid), error);
        }
    }

    onChatMsg(msg) {
        this.props.chatStore.addTextMsg(RoomClient.getUser(msg.from), msg.text);
    }

    onBanChat(data) {
        this.props.chatStore.addBanChat(RoomClient.getUser(data.userid), data.minutes);
    }

    onAddBlack(data) {
        this.props.chatStore.addBlacklist(RoomClient.getUser(data.userid));
    }

    onStopVideo(video) {
        if (video.operid && video.userid !== video.operid) {
            this.props.chatStore.addDownMic(RoomClient.getUser(video.userid),
                                            (video.operid === this.props.roomInfo.ownerId));
            if (RoomClient.getUserId() === video.userid) {
                const text = (video.operid === this.props.roomInfo.ownerId) ? this.props.t('you are down mic by owner') : this.props.t('you are down mic by manager');
                MessageBox.show({
                    text: text,
                    position: "top",
                    duration: 5000
                });
            }
        }
    }

    onDisconnect() {
        //this.props.chatStore.addTip("与服务器失去连接，正在尝试重连");
        console.warn('与服务器失去连接，正在尝试重连');
    }

    getStayTime() {
        let now = new Date();
        let secs = RoomClient.stayTime;
        if (RoomClient.joinTime) {
            secs += parseInt((now.getTime() - RoomClient.joinTime.getTime()) / 1000);
        }

        let hour = parseInt(secs / 3600);
        secs -= hour * 3600;
        let minute = parseInt(secs / 60);
        secs -= minute * 60;
        var stayTime = null;
        if (hour > 0) {
            stayTime = ("0" + hour).slice(-2) + ":" + ("0" + minute).slice(-2) + ":" + ("0" + secs).slice(-2);
        } else {
            stayTime = ("0" + minute).slice(-2) + ":" + ("0" + secs).slice(-2);
        }
        return stayTime;
    }

    onStayTime() {
        this.setState({stayTime: this.getStayTime()});
    }

    onWebLinkClick(e) {
        var names = e.url.split('://')[1].split('/');
        var userid = 0;
        if (names[0] == 'user') {
            userid = names[1].trim();
        }
        if (userid) {
            this.props.onUserMenu(userid, e.globalX, e.globalY);
        }
    }

    onChatHeight(height) {
        this.setState({chatHeight: height});
    }

    renderStayTime() {
        return (<View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 8 }}
                      pointerEvents='none'>
                    <View style={{backgroundColor: '#373737', borderRadius: 5,
                                  paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4}}>
                        <Text style={{color: '#fff', fontSize: 12}}>{this.props.t('stayTime', {time: this.state.stayTime})}</Text>
                    </View>
                </View>);
    }

    renderChatHeight() {
        const isFollowed = this.props.roomInfo.isFollowed;
        const isMyRoom = (RoomClient.getUserId() === this.props.roomInfo.ownerId);
        var popupHeight = Dimensions.get("window").height / 2 - 40;
        if (popupHeight > 300) {
            popupHeight = 300;
        }

        if (this.state.chatHeight + 40 < popupHeight) {
            popupHeight = this.state.chatHeight + 40;
        }
        return (<View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, flex: 1, zIndex: 1}}
                pointerEvents='box-none'>
                <View pointerEvents='none' style={{flex: 1}}/>
                {/* TODO: 需要动态计算offset?
                    https://stackoverflow.com/questions/62549880/react-native-keyboard-avoiding-view
                 */}
                <View style={{height: this.state.keyboard ? popupHeight : this.props.chatHeight}}>
                <ChatView style={{flex: 1, backgroundColor: 'rgba(255,255,255,0)'}}
                ref={this.setupChatView} onHeight={(height) => this.onChatHeight(height)}
                store={this.props.chatStore} onClick={(e) => this.onWebLinkClick(e)}/>
                <View style={{height: 40, flexDirection: 'row', alignItems: 'center'}}>
                <Button transparent style={{width: 30, height: 30, marginLeft: 6,
                                            alignItems: 'center', justifyContent: 'center',
                                            backgroundColor: '#f1f1f1', borderRadius: 15}}
                onPress={() => this.props.onShare()}>
                <Icon name="ios-person-add" style={{ fontSize: 24, color:"#f84070" }}/>
                </Button>
                {isMyRoom ? null :
                 (<Button transparent style={{height: 30, paddingLeft: 0, paddingRight: 0,
                                              marginLeft: 6, paddingTop: 0, paddingBottom: 0,
                                              backgroundColor: '#49d273', borderRadius: 15}}
                  onPress={() => {
                      this.props.onFollow();
                  }}>
                  <LinearGradient start={{ x : 0.0, y : 0 }} end={{ x : 1, y : 0 }}
                  colors={['#3dd078', '#a2e053']} style={{flexDirection: 'row', alignItems: 'center',
                                                          height: 30, borderRadius: 15,
                                                          paddingLeft: 8, paddingRight: 8,}}>
                  <Text style={{ fontSize: 14, color:"#fff"}}>{isFollowed ? this.props.t("followed") : this.props.t("follow")}</Text>
                  </LinearGradient>
                  </Button>)}
                <View style={{flex: 1, flexDirection: 'row', alignItems: 'center',
                              height: 30, borderRadius: 15, backgroundColor: '#f1f1f1',
                              marginLeft: 6, marginRight: 6, paddingLeft: 8, paddingRight: 8}}>
                <TextInput style={{ flex: 1, fontSize:14, paddingTop: 0, paddingBottom: 0 }}
                onChangeText={text => this.setState({text: text})}
                placeholder={this.props.t("say a few words")}
                value={this.state.text} maxLength={1000}/>
                </View>
                {this.state.text ?
                 (<Button transparent style={{height: 30, paddingLeft: 8, paddingRight: 8,
                                              marginLeft: 0, marginRight: 6, paddingTop: 0, paddingBottom: 0,
                                              backgroundColor: '#49d273', borderRadius: 4}}
                  onPress={() => this._handleSendMessage()}>
                  <Text style={{ fontSize: 14, color:"#fff"}}>{this.props.t("send")}</Text>
                  </Button>) : null}
                </View>
                </View>
                </View>
        );
    }

    renderNormal() {
        const isFollowed = this.props.roomInfo.isFollowed;
        const isMyRoom = (RoomClient.getUserId() === this.props.roomInfo.ownerId);
        return (<View style={{flex: 1, backgroundColor: '#252631', position: 'relative'}}
                onLayout={(e) => {
                    if (e.nativeEvent.layout.height < 40) {
                        this.setState({popupInput: true});
                    }
                    else {
                        this.setState({popupInput: false});
                    }
                }}>
                <View style={{display: 'flex', position: 'absolute', left: 0, top: 0, right: 0, bottom: 0}}>
                {this.renderStayTime()}
                {/* TODO: 需要动态计算offset?
                    https://stackoverflow.com/questions/62549880/react-native-keyboard-avoiding-view
                 */}
                <View style={{flex: 1}}>
                <ChatView style={{flex: 1, backgroundColor: '#252631'}}
                store={this.props.chatStore} onClick={(e) => this.onWebLinkClick(e)}/>
                {IsMobile() ? (<View style={{height: 40}}/>) : null}
                {/*<ChatInput chatStore={this.props.chatStore} roomInfo={this.props.roomInfo}
                   onShare={this.props.onShare} onFollow={this.props.onFollow}/>*/}
                </View>
                </View>
                </View>
        );
    }

    render() {
        return this.renderNormal();
        /*
        if (this.props.chatHeight) {
            return this.renderChatHeight();
        }
        return this.renderNormal();
        */
    }

    _handleSendMessage = () => {
        const text = this.state.text;
        RoomClient.sendChatMsg({text: text}, (resp) => {
            if (resp.error) {
                MessageBox.show({
                    text: this.props.t(resp.message),
                    position: "top",
                    duration: 5000
                });
            }
            else {
                this.props.chatStore.addTextMsg(RoomClient.getUser(RoomClient.userid), text);
            }
        });
        this.setState({text: ''});
    };
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default withTranslation(uid, { withRef: true })(ChatPanel);
